/**
* ***************************
* GlobalSubNav Routes in Email Gateway *
* ***************************
*/
import domains from './domains';

/**
 * **********************************
 * System Setting Routes Components *
 * **********************************
 */

 const SysSettingsMain = () =>
 import('@/components/SysSettings/SysSettingsMain');
const EmailDomainList = () =>
 import('@/components/SysSettings/EmailDomainList/EmailDomainList');
const BusinessContinuity = () =>
 import('@/components/SysSettings/BusinessContinuity/BusinessContinuityMain');
const EmailFooter = () => import('@/components/SysSettings/EmailFooter');
const MailboxSetting = () => import('@/components/SysSettings/MailboxSetting');
const SpamNotification = () =>
 import('@/components/SysSettings/SpamNotification');
const VirusSetting = () =>
 import('@/components/SysSettings/VirusSetting/VirusSetting');

export default {
    parent: 'Email Gateway',
    path: '/email-gateway',
    redirect: '/email-gateway/domains',
    component: SysSettingsMain,
    permission: [
        {
            action: 'view',
            entity: 'organisation'
        },
        { action: 'view', entity: 'email_gateway' }
    ],
    name: 'sysSettings',
    children: [
        domains,
        {
            title: 'WhiteList/BlackList',
            link: '/email-gateway/whitelist-blacklist',
            path: 'whitelist-blacklist',
            component: EmailDomainList,
            permission: [{ action: 'view', entity: 'email_gateway' }],
            meta: {
                permission: [{ action: 'view', entity: 'email_gateway' }]
            }
        },
        {
            link: '/email-gateway/mailbox-settings',
            title: 'Mailbox Settings',
            path: 'mailbox-settings',
            component: MailboxSetting,
            permission: [{ action: 'view', entity: 'email_gateway' }],
            meta: {
                permission: [{ action: 'view', entity: 'email_gateway' }]
            }
        },
        {
            link: '/email-gateway/virus-settings',
            title: ' Virus Settings',
            path: 'virus-settings',
            component: VirusSetting,
            permission: [{ action: 'view', entity: 'email_gateway' }],
            meta: {
                permission: [{ action: 'view', entity: 'email_gateway' }]
            }
        },
        {
            link: '/email-gateway/spam-notifications',
            title: 'Spam Notifications',
            path: 'spam-notifications',
            component: SpamNotification,
            permission: [{ action: 'view', entity: 'email_gateway' }],
            meta: {
                permission: [{ action: 'view', entity: 'email_gateway' }]
            }
        },
        // {
        //     link: '/email-gateway/real-time-status',
        //     title: 'Real Time Status'
        // },
        {
            link: '/email-gateway/email-footer',
            title: 'Email Footer',
            path: 'email-footer',
            component: EmailFooter,
            permission: [{ action: 'view', entity: 'email_gateway' }],
            meta: {
                permission: [{ action: 'view', entity: 'email_gateway' }]
            }
        },
        {
            link: '/email-gateway/business-continuity',
            title: 'Business Continuity',
            path: 'business-continuity',
            component: BusinessContinuity,
            permission: [{ action: 'view', entity: 'email_gateway' }],
            meta: {
                permission: [{ action: 'view', entity: 'email_gateway' }]
            }
        }
    ]
};